var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1187 5.5L19.499 15.5251C19.3406 18.0864 19.2615 19.3671 18.6195 20.2879C18.302 20.7431 17.8934 21.1273 17.4194 21.416C16.4608 22 15.1777 22 12.6114 22C10.0418 22 8.75695 22 7.7977 21.4149C7.32345 21.1257 6.91465 20.7408 6.59733 20.2848C5.95553 19.3626 5.8781 18.0801 5.72326 15.5152L5.11865 5.5",
    stroke: "#FC4949",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61865 5.5H21.6187M16.6744 5.5L15.9918 4.09173C15.5383 3.15626 15.3115 2.68852 14.9204 2.39681C14.8337 2.3321 14.7418 2.27454 14.6457 2.2247C14.2126 2 13.6928 2 12.6532 2C11.5875 2 11.0547 2 10.6143 2.23412C10.5168 2.28601 10.4236 2.3459 10.3359 2.41317C9.94029 2.7167 9.71928 3.20155 9.27726 4.17126L8.67157 5.5",
    stroke: "#FC4949",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1187 16.5V10.5",
    stroke: "#FC4949",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1187 16.5V10.5",
    stroke: "#FC4949",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.6e8bacd0779387f37618a49ec4ed6b63.svg";
export { ForwardRef as ReactComponent };